import React, { useEffect, useState } from 'react'
import CannotProcessPermitView from './components/CannotProcessPermitView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const CannotProcessPermit = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('cannot-process-permit', 'Renew your Vehicle Permit', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <CannotProcessPermitView setIsError={setIsError} />
}

export default withTranslation('common')(CannotProcessPermit)
